import { useState, useEffect, useRef } from "react";
import { useRouter } from "next/router";
import styles from "../../styles/components/searchFigma/PickOneModal.module.css";

export default function PickOneModal({ isOpen, closeModal, handleSortChange }) {
  const router = useRouter();
  const { query } = router;
  const modalRef = useRef(null);

  const currentSort = query.sort || "all";
  const [selectedSort, setSelectedSort] = useState(currentSort);
  const [startY, setStartY] = useState(0);
  const [currentY, setCurrentY] = useState(0);
  const [isDragging, setIsDragging] = useState(false);

  // ✅ 모달이 열릴 때 transform 초기화
  useEffect(() => {
    if (isOpen && modalRef.current) {
      modalRef.current.style.transform = "translateY(0)";
    }
  }, [isOpen]);

  useEffect(() => {
    setSelectedSort(currentSort);
  }, [currentSort]);

  const handleSelect = (sortType) => setSelectedSort(sortType);

  const handleApply = () => {
    handleSortChange(selectedSort);
    closeModal();
  };

  // === 드래그 핸들러 ===
  const handleDragStart = (e) => {
    setIsDragging(true);
    setStartY(e.touches ? e.touches[0].clientY : e.clientY);
  };

  const handleDragMove = (e) => {
    if (!isDragging) return;
    const y = e.touches ? e.touches[0].clientY : e.clientY;
    const diff = y - startY;

    // 아래로만 이동 가능하도록
    if (diff > 0 && modalRef.current) {
      modalRef.current.style.transform = `translateY(${diff}px)`;
      setCurrentY(diff);
    }
  };

  const handleDragEnd = () => {
    if (!isDragging) return;
    setIsDragging(false);

    // 일정 거리(예: 100px) 이상 내리면 닫기
    if (currentY > 100) {
      closeModal();
    } else {
      // 아니면 원래 위치로 복귀
      if (modalRef.current) {
        modalRef.current.style.transition = "transform 0.3s ease";
        modalRef.current.style.transform = "translateY(0)";
        setTimeout(() => {
          if (modalRef.current) modalRef.current.style.transition = "";
        }, 300);
      }
    }
  };

  return (
    <>
      <div
        className={`${styles.modalOverlay} ${isOpen ? styles.show : ""}`}
        onClick={closeModal}
      >
        <div
          ref={modalRef}
          className={`${styles.modalContainer} ${isOpen ? styles.slideUp : ""}`}
          onClick={(e) => e.stopPropagation()}
          onMouseMove={handleDragMove}
          onMouseUp={handleDragEnd}
          onMouseLeave={handleDragEnd}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
        >
          {/* 드래그 가능한 핸들 */}
          <div
            className={styles.bottomSheetHandle}
            onMouseDown={handleDragStart}
            onTouchStart={handleDragStart}
          >
            <div className={styles.handle}></div>
          </div>

          {/* 정렬 선택 리스트 */}
          <div className={styles.Frame1101}>
            {[
              { key: "all", label: "메타서치" },
              { key: "day", label: "납기순" },
              { key: "qty", label: "재고순" },
              { key: "keyword", label: "검색어만" },
            ].map((item) => (
              <div
                key={item.key}
                className={styles.buttonText}
                onClick={() => handleSelect(item.key)}
              >
                <div
                  className={`${
                    selectedSort === item.key
                      ? styles.activeText
                      : styles.inactiveText
                  } body3`}
                >
                  {item.label}
                </div>
              </div>
            ))}
          </div>

          {/* 적용 버튼 */}
          <div className={styles.component2}>
            <div className={styles.buttonFillPrimary} onClick={handleApply}>
              <div className={`${styles.redbutton} body3`}>적용하기</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
